import { Loader2 } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { Skeleton } from '../../../components/ui/skeleton';

interface LoadingOverlayProps {
  message?: string;
  variant?: 'spinner' | 'skeleton';
  skeletonRows?: number;
  fullPage?: boolean;
  className?: string;
}

export function LoadingOverlay({
  message,
  variant = 'spinner',
  skeletonRows = 3,
  fullPage = false,
  className,
}: LoadingOverlayProps) {
  if (variant === 'skeleton') {
    return (
      <div className={cn('w-full space-y-2', className)}>
        {Array.from({ length: skeletonRows }).map((_, index) => (
          <Skeleton key={index} className="h-10 w-full rounded" />
        ))}
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center p-8',
        fullPage &&
          'fixed inset-0 z-[9999] bg-background/80 backdrop-blur-sm',
        className
      )}
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      {message && (
        <p className="mt-4 text-sm text-muted-foreground">{message}</p>
      )}
    </div>
  );
}
